import React from "react";

// Components
import TitleComponent from "../../components/TitleComponent";
import CartItemsComponent from "./CartItemsComponent";
const titleLabel = "Confira aqui o resumo do seu descarte ecológico";

function OrderCartComponent(props) {


    return (
        <>
            {props.isOffCanvas ? (
                <div className={`offcanvas offcanvas-end ${props.showOffCanvas ? 'show' : ''}`} data-bs-backdrop="static" tabIndex="-1" id="staticBackdrop" aria-labelledby="staticBackdropLabel" 
                style={{ minWidth: '65%' }} >
                    <div className="offcanvas-header">
                        <h5 className="offcanvas-title" id="staticBackdropLabel">{titleLabel}</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" onClick={props.toggleOffCanvas}></button>
                    </div>
                    <div className="offcanvas-body">
                        <CartItemsComponent />                        
                    </div>
                </div>
            ) : (
                <div className="sticky-top" id="order-card">
                    <div style={{ textAlign: 'center' }} className="mb-3">
                        <TitleComponent title={titleLabel} />
                    </div>
                    <CartItemsComponent />
                </div>
            )}
        </>
    );
}

export default OrderCartComponent;
